import useGetInfo from '../../../../features/product/model/hooks/useGetInfo';
import { useProducts } from '../../../../../redux/reducer/content';

export const useBuyBeautiesModalContent = (productId) => {
  const { buyProducts, productsFromGA } = useProducts();

  const productBuy = buyProducts.find(({ id }) => id === productId);
  const productGA = productsFromGA.find(({ id }) => id === productId);

  const productGAInfo = useGetInfo(productGA);

  return {
    title: productGAInfo?.title ?? productBuy.title,
    beauty_routine_id: productBuy.beauty_routine_id,
    sku: productBuy.sku,
    link: productGAInfo?.link ?? productBuy.link,
    description: productGAInfo?.onlyDescription ?? productBuy.description,
    new_price: productGAInfo?.newPrice ?? null,
    hasFavourite: productBuy.hasFavourite,
    inGaStock: Boolean(productGA),
  };
};
